import { QuestionOption } from '.';
import * as classNames from 'classnames';
import { IFetchedAnswer } from 'common/interfaces/answer';
import { IQuestionWithOptionInfo } from 'common/interfaces/question';
import findIndex from 'lodash-es/findIndex';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./../LeadQuestions.css');
const whiteTickIcon = require('assets/tick white.svg');

// Props
interface IQuestionProps extends IAppOnlyStore {
  questionInfo: IQuestionWithOptionInfo;
  child: boolean;
  index: number;
}

// Component
@inject('store')
@observer
export class Question extends React.Component<IQuestionProps, {}> {
  constructor(props: IQuestionProps) {
    super(props);
  }

  @computed private get answerIndex(): number {
    return findIndex(
      this.props.store.answer.answers,
      (answer) => answer.id === this.props.questionInfo.id
    );
  }

  @computed private get answer(): IFetchedAnswer | null {
    const { answer } = this.props.store;

    return this.answerIndex !== -1 ? answer.answers[this.answerIndex] : null;
  }

  @computed private get unanswered(): boolean {
    return (
      this.answer === null ||
      (this.answer.type === 'text' &&
        (typeof this.answer.note === 'undefined' ||
          this.answer.note === null ||
          this.answer.note === '')) ||
      (this.answer.type === 'radio' &&
        (typeof this.answer.answer === 'undefined' ||
          this.answer.answer === null ||
          this.answer.answer.length <= 0)) ||
      (this.answer.type === 'checkbox' &&
        (typeof this.answer.answer === 'undefined' ||
          this.answer.answer === null ||
          this.answer.answer.length <= 0)) ||
      (this.answer.type === 'select' &&
        (typeof this.answer.answer === 'undefined' ||
          this.answer.answer === null ||
          this.answer.answer.length <= 0))
    );
  }

  public render() {
    const { questionInfo, index } = this.props;

    if (this.props.child) {
      return this.renderQuestion();
    } else {
      return (
        <div className={s.questionGroup}>
          {this.renderQuestion()}

          {typeof this.props.children !== 'undefined' &&
            this.props.children &&
            this.unanswered === false &&
            this.props.children}
        </div>
      );
    }
  }

  private renderQuestion() {
    const { questionInfo, index } = this.props;

    return (
      <div className={s.question}>
        <h2 className={s.label}>{questionInfo.question}</h2>

        <QuestionOption
          questionInfo={questionInfo}
          answerDetails={this.answer}
          unanswered={this.unanswered}
        />

        {this.props.child === false && <p className={s.index}>{index + 1}</p>}

        <i
          className={classNames(s.status, {
            [s.unanswered]: this.unanswered,
          })}
        >
          {this.answer !== null && <img src={whiteTickIcon} />}
        </i>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Questions/Question/Question.tsx